import { Link } from "react-router-dom"

const FooterForm = (props) => {

    const { isMobile } = props

    return (
        <article className={isMobile ? "flex col gap-1em" : "w50 flex col gap-1em"}>
            <h2 className="footer-title">Contacta</h2>

            <section className="flex gc2 col">
                <label className="footer-text">Telf: +34 986 44 90 90</label>
                <Link to="mailto:info@seneca.tv" className="footer-link-blue">info@seneca.tv</Link>
                <label className="footer-text">Si ya eres usuario contacta a través de:</label>
                <Link to="mailto:soporte@seneca.tv" className="footer-link-blue">soporte@seneca.tv</Link>
                <label className="footer-text">O a través de la web de soporte:</label>
                <Link to="https://soporte.seneca.tv" className="footer-link-blue">soporte.seneca.tv</Link>
            </section>

            <section className="flex gc2 acenter jcenter col">
                <Link to="/contacto/" className="send-button fit mar-30 tacenter">Póngase en contacto con nosotros para más información</Link>
            </section>

            <section className="flex gc2 acenter jcenter gap-20 pad-20">
                <Link to="https://x.com/SenecaSoftware"><i className="bi bi-facebook main-section-icon"></i></Link>
                <Link to="https://www.facebook.com/senecasoftware/?fref=ts"><i className="bi bi-twitter-x main-section-icon"></i></Link>
                <Link to="https://www.linkedin.com/showcase/seneca-software/?originalSubdomain=es"><i className="bi bi-linkedin main-section-icon"></i></Link>
            </section>
        </article>
    )

}

export default FooterForm